import React from 'react';
import { Item } from './Item';

import s from './Stats.module.scss';

type Props = {
  kicker?: React.ReactNode;
  title?: React.ReactNode;
  children: React.ReactNode;
};

interface IStats extends React.FC<Props> {
  Item: typeof Item;
}

const Stats: IStats = function Button({ kicker, title, children }) {
  return (
    <div className={s.stats}>
      <div className={s.stats__container}>
        <header className={s.stats__header}>
          {kicker && <p className={s.stats__kicker}>{kicker}</p>}
          {title && <h2 className={s.stats__title}>{title}</h2>}
        </header>
      </div>
      <div className={s.stats__container}>
        <ul className={s.stats__list}>
          {React.Children.map(children, (c, i) => (
            <li key={i} className={s.stats__item}>
              {c}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

Stats.Item = Item;

export { Stats };
